<template>
    <Heading
        :label="__('Register')"
        :description="__('Register a new account')"
        type="h1"
        class="text-center"
    />

    <form @submit.prevent="submit">
        <div class="grid sm:grid-cols-2 gap-3">
            <InputLabel
                :label="__('First name')"
                id="first_name"
                v-model="form.first_name"
                autocomplete="first_name"
            />
            <InputLabel
                :label="__('Last name')"
                id="last_name"
                v-model="form.last_name"
                autocomplete="family-name"
            />
            <div class="sm:col-span-2 grid grid-cols-2 xs gap-3">
                <InputLabel
                    :label="__('Street')"
                    id="street"
                    v-model="form.street"
                    autocomplete="address-line1"
                />
                <div class="grid grid-cols-2 gap-3">
                    <InputLabel
                        :label="__('Building')"
                        id="building"
                        v-model="form.building"
                        autocomplete="address-line2"
                    />
                    <InputLabel
                        :label="__('Flat')"
                        id="flat"
                        v-model="form.flat"
                        autocomplete="address-line3"
                    />
                </div>
            </div>
            <InputLabel
                :label="__('Zip')"
                id="zip"
                v-model="form.zip"
                autocomplete="postal-code"
            />
            <InputLabel
                :label="__('City')"
                id="city"
                v-model="form.city"
                autocomplete="city"
            />
            <Select
                :label="__('Country')"
                v-model="form.country"
                :data="countries"
                id="country"
            >
                <template #display="props">
                    <div class="flex items-center">
                        {{ __(props.data[props.value]) }}
                        <img class="mx-1 w-6 h-6 max-w-max" :src="getLangImage(props.value)">
                    </div>
                </template>
                <template #default="props">
                    <Option
                        v-for="(item, key) in props.data"
                        :key="key"
                        @click="props.clicked(key)"
                        class="flex justify-between"
                        color="yellow"
                        :selected="props.active == key"
                    >
                        {{ __(item) }}
                        <img class="mx-1 w-6 h-6 max-w-max" :src="getLangImage(key)">
                    </Option>
                </template>
            </Select>
            <InputLabel
                :label="__('Phone')"
                id="phone"
                v-model="form.phone"
                autocomplete="tel"
            />

            <div class="sm:col-span-2 border-t mt-4 pt-4">
                <InputLabel
                    :label="__('Email')"
                    id="email"
                    type="email"
                    v-model="form.email"
                    autocomplete="email"
                />
            </div>
            <div class="sm:col-span-2 grid grid-cols-2 xs gap-3">
                <InputLabel
                    :label="__('Password')"
                    id="password"
                    type="password"
                    v-model="form.password"
                    autocomplete="new-password"
                >
                <template #addons>
                    <p class="mt-1 text-xs text-gray-500 leading-normal">
                    {{ __('The :attribute must be at least :length characters and contain at least one uppercase and one lowercase letter', {
                        attribute: __('password'),
                        length: 8
                    }) }}
                    </p>
                </template>
                </InputLabel>
                <InputLabel
                    :label="__('Confirm Password')"
                    id="password_confirmation"
                    type="password"
                    v-model="form.password_confirmation"
                    autocomplete="new-password"
                />
            </div>
        </div>

        <div class="flex items-center justify-end mt-4">
            <InertiaLink :href="route('login')" class="underline text-sm text-gray-600 hover:text-gray-900">
                {{__('Already registered?')}}
            </InertiaLink>

            <breeze-button padding="md" class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                {{__('Register')}}
            </breeze-button>
        </div>
    </form>
</template>

<script>
    import BreezeButton from 'UI/Button'
    import BreezeGuestLayout from '@/Layouts/Guest'
    import BreezeValidationErrors from 'COMP/ValidationErrors'

    import InputLabel from 'UI/InputLabel';
    import Heading from 'COMP/Heading';
    import Select from 'COMP/CustomSelect/Select';
    import Option from 'COMP/CustomSelect/Option';

    import { getLangImage } from 'helper';

    export default {
        layout: BreezeGuestLayout,

        components: {
            BreezeButton,
            InputLabel,
            BreezeValidationErrors,
            Heading,
            Select,
            Option
        },

        props: ['countries'],

        data() {
            return {
                form: this.$inertia.form({
                    first_name: '',
                    last_name: '',
                    city: '',
                    street: '',
                    zip: '',
                    building: '',
                    flat: '',
                    phone: '',
                    email: '',
                    country: Object.keys(this.$props.countries).includes(this.$page.props.locale) ? this.$page.props.locale : null,
                    password: '',
                    password_confirmation: '',
                    terms: false,
                })
            }
        },

        methods: {
            submit() {
                this.form.post(this.route('register'), {
                    onFinish: () => this.form.reset('password', 'password_confirmation'),
                })
            }
        },

        setup(props) {
            return {
                getLangImage
            }
        }
    }
</script>
